import { render } from "./EditTeam.vue?vue&type=template&id=5a2334fc&scoped=true"
import script from "./EditTeam.vue?vue&type=script&lang=js"
export * from "./EditTeam.vue?vue&type=script&lang=js"

import "./EditTeam.vue?vue&type=style&index=0&id=5a2334fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2334fc"]])

export default __exports__